import { z } from 'zod';

import { membershipOwnerSchema, membershipRoleSchema } from '../membership';
import { payoutOwnerSchema } from '../payout';
import { ulidSchema } from '../primitives';

export const restaurantMemberPathParamsSchema = z.object({
  id: ulidSchema,
  /** Target member Cognito `sub`. */
  userId: z.string().min(1).max(128),
});
export type RestaurantMemberPathParams = z.infer<typeof restaurantMemberPathParamsSchema>;

/** Adds an existing Cognito user by their email address as ADMIN or STAFF. */
export const postRestaurantMemberInviteRequestSchema = z.object({
  email: z.string().email(),
  role: z.enum(['ADMIN', 'STAFF']),
});
export type PostRestaurantMemberInviteRequest = z.infer<
  typeof postRestaurantMemberInviteRequestSchema
>;

export const postRestaurantMemberInviteResponseSchema = z.object({
  restaurantId: ulidSchema,
  userId: z.string().min(1).max(128),
  role: membershipRoleSchema,
});
export type PostRestaurantMemberInviteResponse = z.infer<
  typeof postRestaurantMemberInviteResponseSchema
>;

export const listRestaurantMembersResponseSchema = z.object({
  items: z.array(membershipOwnerSchema),
});
export type ListRestaurantMembersResponse = z.infer<typeof listRestaurantMembersResponseSchema>;

export const listRestaurantPayoutsResponseSchema = z.object({
  items: z.array(payoutOwnerSchema),
});
export type ListRestaurantPayoutsResponse = z.infer<typeof listRestaurantPayoutsResponseSchema>;

export const listRestaurantDisputesWireQuerySchema = z
  .object({
    limit: z.coerce.number().int().optional(),
    cursor: z.string().optional(),
    stage: z.enum(['AWAITING_RESTAURANT', 'AWAITING_ADMIN']).optional(),
  })
  .transform((value) => ({
    limit:
      value.limit !== undefined &&
      Number.isFinite(value.limit) &&
      value.limit > 0 &&
      value.limit <= 100
        ? value.limit
        : 25,
    ...(value.cursor !== undefined && value.cursor.trim().length > 0
      ? { cursor: value.cursor.trim() }
      : {}),
    ...(value.stage !== undefined ? { stage: value.stage } : {}),
  }));

export type ListRestaurantDisputesWireQuery = z.infer<typeof listRestaurantDisputesWireQuerySchema>;
